import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const BrokenLinksLinks = lazy(() => import('./BrokenLinks'));

export const BrokenLinks: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<BrokenLinksLinks {...props} />
	</Suspense>
);
